import { useDraggable } from '@dnd-kit/core';
import { StyledDraggableText } from './DraggableText.styled';
import { SoundOutlined } from '@ant-design/icons';
import { GameStageContext } from '@/shared/GameComponents/GameStageContext/GameStageContext';
import { useContext, useMemo, useRef } from 'react';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';

export default function DraggableText({ txt, onClick }) {
  const game = useContext(GameLoopContext);
  const gameStage = useContext(GameStageContext);
  const textRef = useRef();

  const { x, y, answer } = useMemo(() => {
    const gameFinished = game.state.finished;
    const answer = game.state.answersLog.find((answer) => answer.id == txt.id);

    const textTransform =
      answer?.correct || gameFinished ? txt.correctTransform : txt.transform;
    const x =
      (textTransform.x / 100) * gameStage.state.width -
      (textRef.current?.clientWidth * (textTransform.pivot?.x ?? 0)) / 100;
    const y =
      (textTransform.y / 100) * gameStage.state.height -
      (textRef.current?.clientHeight * (textTransform.pivot?.y ?? 0)) / 100;
    return {
      x,
      y,
      answer,
    };
  }, [
    game.state.finished,
    game.state.answersLog,
    txt.correctTransform,
    txt.transform,
    textRef.current,
    gameStage.state.width,
    gameStage.state.height,
  ]);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform: draggingTransform,
  } = useDraggable({
    id: txt.id,
    disabled: !!answer,
  });
  return (
    <StyledDraggableText
      style={{
        transform: `translate(${x}px, ${y}px)`,
        position: 'absolute',
      }}
      stage={gameStage.state}
      txt={txt}
      º
      onClick={onClick}
    >
      <div
        className={`draggable-text ${answer ? 'answered' : ''} ${
          answer && !answer.correct ? 'wrong' : ''
        } ${answer && answer.correct ? 'correct' : ''}`}
        ref={(ref) => {
          textRef.current = ref;
          setNodeRef(ref);
        }}
        style={
          draggingTransform
            ? {
                transform: `translate(${draggingTransform.x}px, ${draggingTransform.y}px)`,
              }
            : {}
        }
        {...listeners}
        {...attributes}
      >
        <Txt txt={txt} />
      </div>
    </StyledDraggableText>
  );
}

const availableIcons = {
  soundIcon: SoundOutlined,
};

export function Txt({ txt }) {
  let isLongText = false;
  if (txt.icon) {
    const Icon = availableIcons[txt.icon];
    return <Icon className="icon" />;
  } else {
    let textParts = [];

    if (txt.text.includes('/')) {
      textParts = txt.text.split('/');
    } else if (txt.text.includes('#')) {
      textParts = txt.text.split('#');
      isLongText = true;
    } else {
      textParts = [txt.text];
    }

    return (
      <div
        className={`txt ${textParts.length > 1 ? 'multiline' : ''} ${
          isLongText ? 'long-text' : ''
        }`}
      >
        {textParts.map((part, idx) => (
          <span key={idx}>
            {part}
            {textParts.length ? <br /> : null}
          </span>
        ))}
      </div>
    );
  }
}
